import { useEffect } from 'react';
import isSize, { useIsSize } from '../utils/responsive/isSize';
import Sizes from '../utils/responsive/Sizes';

const breakPointSize = Sizes.SM;

export const getScrollContainer = () => {
  if (isSize(breakPointSize)) {
    return document.documentElement;
  }
  const content = document.querySelector('#content');
  return content instanceof HTMLElement ? content : null;
};

const listenToPostScroll = (handler: (element: HTMLElement) => void) => {
  const scrollContainer = getScrollContainer();

  if (!scrollContainer) {
    return () => {};
  }

  const listener = () => handler(scrollContainer);

  const target =
    scrollContainer === document.documentElement ? document : scrollContainer;

  target.addEventListener('scroll', listener);
  return () => {
    target.removeEventListener('scroll', listener);
  };
};

export const useListenToPostScroll = (
  handler: (element: HTMLElement) => void,
) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const matched = useIsSize(breakPointSize);

  useEffect(() => {
    return listenToPostScroll(handler);
  }, [handler, matched]);
};

export default listenToPostScroll;
